import { events } from './actions';
import {getStepTypes, getVariant, getVariantId, getVariantImageUrl, getVariantImageUrlAsync, createImageNameFromValue} from './utilities';
import smoothScroll from 'smoothscroll';
import bb from 'blingblingjs';
import { isEmpty } from 'lodash-es';
import OptionTemplate from '../../../../snippets/add-to-basket__option.liquid';
import OptionTemplateMobile from '../../../../snippets/add-to-basket__option-mobile.liquid';
import { Liquid } from 'liquidjs';
import {headroom} from '../../header';
import Drift from 'drift-zoom';
import {breakpoints} from '../../config';
import * as images from '@shopify/theme-images';

const shopifyFilesUrl = '//cdn.shopify.com/s/files/1/0357/6833/6519/files/'


var engine = new Liquid();
engine.registerFilter('asset_url', v => shopifyFilesUrl + v);


let imageZooms = [];

const uiParts = [

    /* ----------------------------------------------------- */
    /* ----------  The main configurator container ---------- */
    /* ------------------------------------------------------ */

    function container(state, valueHasChanged){
            
            const el = bb('.js-el__add-to-basket-container')[0];
            

        /*
            var anchor = document.querySelector("#add-to-basket");

            if(state.configuratorIsOpen && (anchor.getBoundingClientRect().top > 10 || anchor.getBoundingClientRect().top < -10)){
                headroom.unpin()
                headroom.freeze()
                smoothScroll(anchor, 500, () => {headroom.unfreeze(); headroom.unpin();});
                
            }
            if(state.configuratorIsOpen) {
                headroom.unpin()
                headroom.freeze()
            } else {
                headroom.unfreeze()
            }
        */
            el.classList.toggle( "--configurator-is-open", state.configuratorIsOpen);
           
        
    },


    /* ------------------------------------------------------ */
    /* --             A configuration step                 -- */
    /* ------------------------------------------------------ */

    function configuratorSteps(state, valueHasChanged){
        if (!valueHasChanged('currentStep') && !valueHasChanged('currentSubStep') && state.currentStep !== 1) { return }
       
            const els = bb('.js-el__configurator-step');

            els.forEach((el) => {
                // Set the step to show if required
                if(el.dataset.step == state.currentStep && state.configuratorIsOpen) {
                    el.classList.add('--is-current-step')
                } else {
                    el.classList.remove('--is-current-step')
                }
            })
        
    },


    /* ------------------------------------------------------ */
    /* --                   Mobile Split Step              -- */
    /* ------------------------------------------------------ */

    function configuratorMobileSubStep(state, valueHasChanged){
        if (!valueHasChanged('currentStep') && !valueHasChanged('currentSubStep') && state.currentStep !== 1) { return }
        const els = bb('.js-el__configurator-mobile-sub-step');

        els.forEach((el) => {
            // Set the step to show if required
            if(el.dataset.substep == state.currentSubStep && state.configuratorIsOpen) {
                el.classList.add('--is-current')
            } else {
                el.classList.remove('--is-current')
            }
        })
    
    },


    /* ------------------------------------------------------ */
    /* --             Filtered Options / Groups            -- */
    /* ------------------------------------------------------ */

    function configuratorFilterItems(state, valueHasChanged){
        const els = bb('.js-el__configurator-filtered-item');

        els.forEach((el) => {
            // Set the step to show if required
            const filterValue = el.dataset.filterValue.toLowerCase();
            const filterStep = el.dataset.filterStep;

            if (state.chosenOptions[filterStep - 1].value == filterValue) {
                el.classList.add('--matches-filter')
            } else {
                el.classList.remove('--matches-filter')
            }
            
        })
    
    },

    

    /* ------------------------------------------------------ */
    /* -     A configuration step option group              - */
    /* ------------------------------------------------------ */

    function optionGroups(state, valueHasChanged){

        if(valueHasChanged('chosenOptions') || state.stepExpanded === true){
            const els = bb('.js-el__option-group');

            const stepTypes = getStepTypes();

            // console.log("optionGroups");
            // console.trace();
            
            els.forEach((el) => {
                const step = el.dataset.step;
                const step0 = step - 1;
                const imagePrefix = el.dataset.imagePrefix;
                const imageSuffix = el.dataset.imageSuffix;
                const imageTrim = el.dataset.imageTrim;
                const splitOption = el.dataset.splitoption;
                const splitOption0 = splitOption - 1;
                const repopulate = el.dataset.repopulate;
                let groupHasValue = false;
                let html = '';

                if(repopulate) {
                    if(stepTypes[step0].type == 'option'){
                        html = '';
                        if(el.dataset.mobile) {
                            state.stepData[step0].forEach(item => {
                                const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                html += engine.parseAndRenderSync(OptionTemplateMobile,  {title: getTranslation(item), value : item, step : step, image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded });
                            })
                        } else {
                            state.stepData[step0].forEach(item => {
                                const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                html += engine.parseAndRenderSync(OptionTemplate,  {title: getTranslation(item), value : item, step : step, image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded });
                            })
                        }
                    }
                    if(stepTypes[step0].type == 'splitOption'){
                        html = '';
                        if(el.dataset.mobile) {
                            if(splitOption0 == 0){
                                state.stepData[step0][splitOption0].forEach(item => {
                                    const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                    html += engine.parseAndRenderSync(OptionTemplateMobile, {title: getTranslation(item), value : item, step : step, splitoption : splitOption,  image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded});
                                })
                            }
                            if(splitOption0 == 1){
                                state.stepData[step0][1][state.stepData[step0][0].indexOf(state.chosenOptions[step0][0].value)].forEach(item => {
                                    const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                    html += engine.parseAndRenderSync(OptionTemplateMobile, {title: getTranslation(item), value : item, step : step, splitoption : splitOption,  image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded});
                                })
                            }
                        } else {
                            if(splitOption0 == 0){
                                state.stepData[step0][0].forEach(item => {
                                    const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                    html += engine.parseAndRenderSync(OptionTemplate, {title: getTranslation(item), value : item, step : step, splitoption : splitOption,   image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded});
                                })
                            }
                            if(splitOption0 == 1){
                                state.stepData[step0][1][state.stepData[step0][0].indexOf(state.chosenOptions[step0][0].value)].forEach(item => {
                                    const imageName = createImageNameFromValue(item, imagePrefix, imageSuffix, imageTrim)
                                    html += engine.parseAndRenderSync(OptionTemplate, {title: getTranslation(item), value : item, step : step, splitoption : splitOption,  image_name: imageName, product_type: state.product.product.product_type, stepExpanded: state.stepExpanded});
                                })
                            }
                        }
                    }
                    el.innerHTML = html;
                }

                
                if(splitOption){
                    groupHasValue = isEmpty(state.chosenOptions[step0][splitOption0]) ? false : true
                } else {
                    groupHasValue = isEmpty(state.chosenOptions[step0]) ? false : true
                }

                el.classList.toggle('--has-chosen-option', groupHasValue);
            })

        }
        
    },

    /* ------------------------------------------------------ */
    /* -                   A single option                  - */
    /* ------------------------------------------------------ */

    function option(state, valueHasChanged){
        
            const els = bb('.js-el__configurator-option');
            els.forEach(el => {
                const value = el.dataset.value.toLowerCase();
                const step = el.dataset.step;
                const splitOption = el.dataset.splitoption;
                const validate = el.dataset.validate;
                let isSelected = false;

                if(splitOption){
                    isSelected = state.chosenOptions[step - 1][splitOption - 1]?.value == value ? true : false
                } else {
                    isSelected = state.chosenOptions[step - 1]?.value == value ? true : false
                }


                if(validate){
                    // check to see if this option is available
                    if(splitOption) {
                        el.classList.toggle('--is-invalid', !state.stepData[step - 1][splitOption - 1].includes(value))
                    }
                    else {
                        el.classList.toggle('--is-invalid', !state.stepData[step - 1].includes(value))
                    }
                }
                
                el.classList.toggle('--is-selected', isSelected);

            })
        
    },

    /* ------------------------------------------------------ */
    /* -                  Info Popups                       - */
    /* ------------------------------------------------------ */

    function infoPopups(state, valueHasChanged){
        if (!valueHasChanged('infoPopup')) { return }
        
            const els = bb('.js-el__configurator-info-popup')
            // Show / hide the relevant info popup
            els.forEach(el => {
                if(el.dataset.popup && state.infoPopup && el.dataset.popup.toLowerCase() == state.infoPopup.toLowerCase()) {
                    el.classList.add('--is-open')
                } else {
                    el.classList.remove('--is-open')
                }
            })
        
    },

    /* ------------------------------------------------------ */
    /* -                  Info Popup Container              - */
    /* ------------------------------------------------------ */

    function infoPopupContainer(state, valueHasChanged){
        if (!valueHasChanged('infoPopup')) { return }

        const els = bb('.js-el__configurator-info-popup-container');
        // Show / hide the relevant info popup
        els.forEach(el => {
            if(el.dataset.popup && state.infoPopup && el.dataset.popup.toLowerCase() == state.infoPopup.toLowerCase()) {
                el.classList.add('--is-open')
            } else {
                el.classList.remove('--is-open')
            }
        })
    
    },

    /* ------------------------------------------------------ */
    /* -                 Option Info                        - */
    /* ------------------------------------------------------ */

    function optionInfo(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions')) { return }

        const els = bb('.js-el__option-info');
        // Show / hide the relevant info popup
        els.forEach(el => {
            if(state.hoverInfo && el.dataset.relatedValue && el.dataset.relatedValue.toLowerCase() == state.hoverInfo.toLowerCase()) {
                el.classList.add('--is-active')
            } 
            else if( !state.hoverInfo && el.dataset.relatedValue && el.dataset.relatedValue.toLowerCase() == state.chosenOptions[el.dataset.step - 1].value.toLowerCase()) {
                el.classList.add('--is-active')
            } else {
                el.classList.remove('--is-active')
            }
        })
    
    },



    /* ------------------------------------------------------ */
    /* -                  Preview Col                       - */
    /* ------------------------------------------------------ */

    function previewCol(state, valueHasChanged){
        if (!valueHasChanged('techSpecsIsOpen') && !valueHasChanged('configuratorIsOpen')) { return }
        
            const els = bb('.js-el__configurator-preview-col, .js-el__product-overview');
            els.forEach((el)=>{
            // Show / hide the relevant info popup
                el.classList.toggle('--has-open-tech-specs', state.techSpecsIsOpen);
                el.classList.toggle('--has-open-configuration-preview', state.configuratorIsOpen);
            });
            /*
            var anchor = document.querySelector("#add-to-basket");

            if(state.techSpecsIsOpen && (anchor.getBoundingClientRect().top > 10 || anchor.getBoundingClientRect().top < -10)){
                headroom.unpin()
                headroom.freeze()
                
                smoothScroll(anchor, 500, () => {headroom.unfreeze(); headroom.unpin();});
            }
            headroom.unfreeze()
            */
    },

    

    /* ------------------------------------------------------ */
    /* -                  Step Indicators                   - */
    /* ------------------------------------------------------ */


    function stepIndicators(state, valueHasChanged){

            const els = bb('.js-el__step-indicator');
            els.forEach((el, index) => {
                // Set the styling
                if( state.currentStep > el.dataset?.targetStep || state.currentStep > index ) {
                    el.classList.add('--is-before-current');
                } else {
                    el.classList.remove('--is-before-current')
                }

                if( el.dataset?.targetStep == state.currentStep || state.currentStep ==  index + 1 ) {
                    el.classList.add('--is-current');
                } else {
                    el.classList.remove('--is-current')
                }
            })

    },


    /* ------------------------------------------------------ */
    /* -             Chosen Option Indicator                - */
    /* ------------------------------------------------------ */


    function chosenOptionIndicator(state, valueHasChanged){
        
            const els = bb('.js-el__chosen-option-indicator');
            els.forEach(el => {
                const step = el.dataset.step;
                const splitOption = el.dataset.splitoption;
                let title = '';
                // Set the text value

                console.log(state.chosenOptions)
                if(splitOption){
                    title = state.chosenOptions[step - 1][splitOption - 1]?.title ? state.chosenOptions[step - 1][splitOption - 1].title : ''; 
                } else {
                    title = state.chosenOptions[step - 1]?.title ? state.chosenOptions[step - 1].title : ''; 
                }
               
                el.innerHTML = getTranslation(title); 
            })
        
    },


    /* ------------------------------------------------------ */
    /* -             Add to basket button container         - */
    /* ------------------------------------------------------ */


    function addToBasketContainer(state, valueHasChanged){
       
            const els = bb('.js-el__add-configuration-to-cart-container');
            const totalSteps = state.chosenOptions.length + 1;
            els.forEach((el)=>el.classList.toggle('--is-active', state.currentStep == totalSteps && state.configuratorIsOpen));
        
    },



    /* ------------------------------------------------------ */
    /* -             Tech Specs Button                      - */
    /* ------------------------------------------------------ */


    function toggleTechSpecs(state, valueHasChanged){
        if (!valueHasChanged('techSpecsIsOpen')) { return }

            const el = bb('.js-el__tech-specs-btn ')[0];
            el.classList.toggle('--is-open', state.techSpecsIsOpen);
        
    },


    /* ------------------------------------------------------ */
    /* -             Summary Page Titles                    - */
    /* ------------------------------------------------------ */


    function summaryPageTitle(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }

        const els = bb('.js-el__configurator-summary-step-title');
        els.forEach(el => {
            const step = el.dataset.step;
            let title = '';
            // Set the text value

            title = state.chosenOptions[step - 1].title ? state.chosenOptions[step - 1].title : 
            Array.isArray(state.chosenOptions[step - 1]) ? state.chosenOptions[step - 1].reduce((acc, item) =>  acc ? acc + ' / ' + item.title : item.title, '') : '';
            
            el.innerHTML = getTranslation(title);
        })
        
    },

    /* ------------------------------------------------------ */
    /* -             Downloads Section                      - */
    /* ------------------------------------------------------ */


    function downloads(state, valueHasChanged){
        if (!valueHasChanged('downloadsIsOpen')) { return }

        const el = bb('.js-el__product-downloads')[0];
        if(typeof el === "undefined"){
            return;
        }
        el.classList.toggle('--is-open', state.downloadsIsOpen)
        
    },


    /* ------------------------------------------------------ */
    /* -             Popular Variants                     - */
    /* ------------------------------------------------------ */


    function popularVariants(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions')) { return }

        const els = bb('.js-el__popular-variant');
        els.forEach(el => {
            
            const handle = el.dataset.productHandle;
            const variant = el.dataset.variant;
            const currentHandle = state.product.product.handle;
            const currentVariant = getVariantId(state, getStepTypes());


            if(variant){
                el.classList.toggle('--is-current', variant == currentVariant);
            } else if(handle == currentHandle && state.product.product.variants[0].id == currentVariant) {
                el.classList.add('--is-current');
            } else {
                el.classList.remove('--is-current');
            }
            
        })
        
    },


    /* ------------------------------------------------------ */
    /* -             Variant Image                 - */
    /* ------------------------------------------------------ */

   
    async function variantImage(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && !state.firstRun) { return }

        const imageEls = bb('.js-el__variant-preview-img');
        const bgImageEls = bb('.js-el__variant-preview-img-bg');
        const loadingEls = bb('.js-el__variant-preview-load-icon');
        const variant = getVariant(state, getStepTypes());
        const variantId = `${variant.id}-${variant.image_id}`;
        console.log('variantImage', state.variantImages[variantId], variantId, variant);
        if (state.variantImages[variantId] == null) {
            state.variantImages[variantId] = {};
        }
        state.variantImageId = variantId;
        if (state.variantImages[variantId] != null && state.variantImages[variantId].main && state.variantImages[variantId].zoom) {
            loadingEls.forEach(el => {
                el.classList.add('--is-showing')
            });
            imageEls.forEach(el => {
                el.classList.add('--is-loading')
            });
            bgImageEls.forEach(el => {
                el.classList.add('--is-loading')
            });
            let callbackFunc = typeof requestIdleCallback != "undefined"? requestIdleCallback : requestAnimationFrame;
            callbackFunc(()=>{
                const imgSrc = state.variantImages[variantId].main;
                imageEls.forEach(el => {
                    el.src = imgSrc;
                })
                bgImageEls.forEach(el => {
                    el.style.backgroundImage = 'url(' + imgSrc + ')';
                    el.src = imgSrc
                });

                let zoomImage = state.variantImages[variantId].zoom;

                imageEls.forEach(el => {
                    el.dataset.zoom = zoomImage;
                })
                bgImageEls.forEach(el => {
                    el.dataset.zoom = zoomImage;
                })

                loadingEls.forEach(el => {
                    el.classList.remove('--is-showing')
                });
                imageEls.forEach(el => {
                    el.classList.remove('--is-loading');
                });
                bgImageEls.forEach(el => {
                    el.classList.remove('--is-loading');
                });
                imageZooms.forEach(item => item.enable());
            })
        } else {
            console.time('variantImage image fetch');
            loadingEls.forEach(el => {
                el.classList.add('--is-showing')
            });
            imageEls.forEach(el => {
                el.classList.add('--is-loading')
            });
            bgImageEls.forEach(el => {
                el.classList.add('--is-loading')
            });
            getVariantImageUrlAsync(state, getStepTypes())
            .then(imgSrc => {
                state.variantImages[variantId].main = imgSrc;
                imageEls.forEach(el => {
                    el.src = imgSrc;
                })
                bgImageEls.forEach(el => {
                    el.style.backgroundImage = 'url(' + imgSrc + ')';
                    el.src = imgSrc
                })

                requestAnimationFrame(() => {
                    loadingEls.forEach(el => {
                        el.classList.remove('--is-showing')
                    });
                    imageEls.forEach(el => {
                        el.classList.remove('--is-loading');
                    });
                    bgImageEls.forEach(el => {
                        el.classList.remove('--is-loading');
                    });
                });

                let zoomImage = imgSrc.replace('1024x1024', '2048x2048');
                state.variantImages[variantId].zoom = zoomImage;
                imageEls.forEach(el => {
                    el.dataset.zoom = zoomImage;
                })
                bgImageEls.forEach(el => {
                    el.dataset.zoom = zoomImage;
                })
                imageZooms.forEach(item => item.enable());
                let event = new CustomEvent('asyncImageUpdate',{detail:{main:imgSrc, zoom:zoomImage}});
                window.dispatchEvent(event);

                console.timeEnd('variantImage image fetch');
            });
        }
    },

    function preloadOtherVariants(state, valueHasChanged) {
        if (!valueHasChanged('chosenOptions')) { return }
        let callbackFunc = typeof requestIdleCallback != "undefined"? requestIdleCallback : requestAnimationFrame;
        callbackFunc(()=>{
            state.product.product.variants.forEach((variant)=>{
                const image = state.product.product.images.find(item =>item.id == variant.image_id);
                const variantId = `${variant.id}-${variant.image_id}`;
                let sizes = ['1024x1024', '2048x2048'];
                let variantSizes = ['main', 'zoom'];
                sizes.forEach((size, index)=>{
                    if (state.variantImages[variantId] == null) {
                        state.variantImages[variantId] = {};
                    }
                    let img = new Image();
                    let imgSrc = images.getSizedImageUrl(image.src, size);
                    img.onload = () => { state.variantImages[variantId][variantSizes[index]] = imgSrc};
                    img.src = imgSrc;
                });
            });
        });
    },

    /* ------------------------------------------------------ */
    /* -             Product Type              - */
    /* ------------------------------------------------------ */


    function productType(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }

        const els = bb('.js-el__product-type');
        els.forEach(el => {
            el.innerHTML = state.product.product.product_type;  
        })  
    },


     /* ------------------------------------------------------ */
    /* -             Product Title             - */
    /* ------------------------------------------------------ */


    function productTitle(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }

        const els = bb('.js-el__product-title');
        els.forEach(el => {
            el.innerHTML = state.product.meta.product_title;  
        })  
    },

    /* ------------------------------------------------------ */
    /* -                   Variant Name                     - */
    /* ------------------------------------------------------ */


    function variantTitle(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }

        const els = bb('.js-el__variant-title');
        els.forEach(el => {
            el.innerHTML = getVariant(state, getStepTypes()).title || '';
        })  
    },

    /* ------------------------------------------------------ */
    /* -                   Product Description              - */
    /* ------------------------------------------------------ */


    function productDescription(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && !valueHasChanged('product')) { return }

        const els = bb('.js-el__product-description');
        els.forEach(el => {
            el.innerHTML = state.product.meta.product_description || state.product.product.body_html || '';
        })  
    },

    /* ------------------------------------------------------ */
    /* -             Price              - */
    /* ------------------------------------------------------ */


    function productPrice(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }
        const els = bb('.js-el__price');

        const price = window.Shopify.formatMoney(getVariant(state, getStepTypes()).price);
        els.forEach(el => {
            el.innerHTML = price;  
        })  
    },



    /* ------------------------------------------------------ */
    /* -             Variant Delivery Time                  - */
    /* ------------------------------------------------------ */


    function deliveryTime(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }

        const els = bb('#add-to-basket .js-el__delivery-info');
        const variantId = getVariantId(state, getStepTypes());
        var locale = Weglot.getCurrentLang();
        if(locale === "en"){
            var delivery_date = state.product.meta.delivery_times.find(item => item.variant_id == variantId)["delivery_time_en"];
        }
        else if(locale === "de") {
            var delivery_date = state.product.meta.delivery_times.find(item => item.variant_id == variantId)["delivery_time_de"];
        }
        else if(locale === "nl") {
            var delivery_date = state.product.meta.delivery_times.find(item => item.variant_id == variantId)["delivery_time_nl"];
        }
        else if(locale === "fr") {
            var delivery_date = state.product.meta.delivery_times.find(item => item.variant_id == variantId)["delivery_time_fr"];
        }
        else if(locale === "it") {
            var delivery_date = state.product.meta.delivery_times.find(item => item.variant_id == variantId)["delivery_time_it"];
        }

        els.forEach(el => {
            el.innerHTML = delivery_date ? ' ' + delivery_date : '';
        });
    },


    /* ------------------------------------------------------ */
    /* -             Summary Page Images                    - */
    /* ------------------------------------------------------ */

    function summaryPageImage(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && state.currentStep !== 1) { return }
        const els = bb('.js-el__configurator-summary-step-image');
        els.forEach((el, index) => {
            const step = el.dataset.step;
            const imagePrefix = el.dataset.imagePrefix ? el.dataset.imagePrefix : undefined;
            const imageSuffix = el.dataset.imageSuffix ? el.dataset.imageSuffix : undefined;
            const imageTrim = el.dataset.imageTrim ? el.dataset.imageTrim : undefined;
            let img;

            if(el.dataset.imageFromValue) {
                img = state.chosenOptions[step - 1].value ? state.chosenOptions[step - 1].value :
                Array.isArray(state.chosenOptions[step - 1]) ? state.chosenOptions[step - 1].reduce((acc, item) =>  acc ? acc + '-' + item.value : item.value, '') : '';
                img = shopifyFilesUrl + createImageNameFromValue(img, imagePrefix, imageSuffix, imageTrim)
            } else {
                bb(`.js-el__configurator-option[data-step="${step}"].--is-selected`).forEach(option => {
                    img = bb('img', option)[0].getAttribute('data-src');
                });
            }
            el.innerHTML = '';
            let newImg = document.createElement("img");
            newImg.src = img
            el.appendChild(newImg);
        })
    },


    function imageZoom(state, valueHasChanged){
        if (!valueHasChanged('chosenOptions') && !state.firstRun) { return }

        if(window.innerWidth >= breakpoints.m) {
            if (imageZooms && !imageZooms.length) {
                const targetNode = document.querySelector('.js-el__configurator-preview-col');
                const config = { childList: true, subtree: true };
                const callback = (mutationList, observer) => {
                    for (const mutation of mutationList) {
                        if (mutation.type === 'childList') {
                            let driftZoomItem = Array.from(mutation.addedNodes).find((ele)=>{
                                return ele.className && ele.className.includes('drift-zoom-pane')
                            });
                            if (driftZoomItem) {
                                driftZoomItem.querySelector('.drift-zoom-pane-loader').innerHTML = `<div class="lds-ring"> <div></div><div></div><div></div><div></div> </div>`;
                            }
                        }
                    }
                };

                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
            bb('.js-el__image-zoom').forEach((el, idx) => {
                if (!imageZooms[idx]) {
                    imageZooms.push(
                        new Drift(el, {
                            paneContainer: bb('.js-el__configurator-preview-col')[0],
                            //inlinePane: true,
                            zoomFactor: 2.5,
                            onShow: () => {
                            }
                        })
                    );
                } else {
                    if (state.variantImageId && state.variantImages[state.variantImageId]) {
                        let zoomImage = state.variantImages[state.variantImageId].zoom;
                        console.log('resetting image', el.dataset.zoom, zoomImage);
                        imageZooms[idx].setZoomImageURL('');
                        imageZooms[idx].zoomPane.settings.container.querySelector('.drift-zoom-pane img').style.transform = ' translate(-25%, -25%);';
                        if (zoomImage){
                            let tempImg= new Image(2048,2048);
                            tempImg.onload = ()=>{
                                imageZooms[idx].setZoomImageURL(zoomImage);
                            };
                            tempImg.src = zoomImage
                        } else {
                            let func = (e)=>{
                                imageZooms[idx].setZoomImageURL(e.detail.zoom);
                                window.removeEventListener('asyncImageUpdate', func);
                            };
                            window.addEventListener('asyncImageUpdate', func);
                        }
                    }
                }
            })
        } else {
            imageZooms.forEach((item)=>{ item && item.destroy() })
        }
    }


];



export function updateUi(state, previousState) {
    function valueHasChanged(key){
        return JSON.stringify(state[key]) != JSON.stringify(previousState[key]) ? true : false;
    }

    if(!areEqualShallow(state, previousState)){
        if (Shopify.theme.role == 'development') {
            var hrLineArr = [];
            var length = 20;
            hrLineArr.length = length;
            hrLineArr.fill('-');

            console.log(hrLineArr.slice(0,(length/2)).join('') + 'updateUi' + hrLineArr.slice((length/2),hrLineArr.length).join(''))
            console.time('updateUi');
            console.groupCollapsed('updateUi');
        }
        uiParts.forEach(item => {
            try {
                if (Shopify.theme.role == 'development') {
                    console.group(item.name);
                    console.time(item.name);
                }
                item(state, valueHasChanged)
                if (Shopify.theme.role == 'development') {
                    console.timeEnd(item.name);
                    console.groupEnd(item.name);
                }
            } catch (error){
                console.log(error)
            }
        });
        state.firstRun = false;
        window.appState = state;
        if (Shopify.theme.role == 'development') {
            console.groupEnd('updateUi');
            console.timeEnd('updateUi');
            console.log(hrLineArr.slice(0,(length/2)).join('') + 'updateUiEnd' + hrLineArr.slice((length/2),hrLineArr.length).join(''))
        }
        events.update();
    }
}


function areEqualShallow(a, b) {
    for(var key in a) {
        if(!(key in b) || a[key] !== b[key]) {
            return false;
        }
    }
    for(var key in b) {
        if(!(key in a) || a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}


function getTranslation(str,category="variant_title") {
    let searchString = str?.toLowerCase().trim();
    let currentLangCode = window.translations.langCode();
    if (str.indexOf('/') != -1) {
        searchString = str.split('/').map(s=>s.trim()).join('/');
    }
    let translation = window.translations.line_item[category][searchString] && window.translations.line_item[category][searchString][currentLangCode] || false;

    if (translation) {
        return capitalize(translation);
    }

    let translationFailed = false;
    let translationArr = searchString.split('/').map((item)=>{
        item = item?.toLowerCase().trim();
        if (!window.translations.line_item[category][item]) {
            translationFailed = true;
        }
        let translationStr = window.translations.line_item[category][item] && window.translations.line_item[category][item][currentLangCode] || false;
        if (translationStr && !translationFailed) {
            return capitalize(translationStr);
        }
        translationFailed = true;
        return capitalize(item);
    });

    if (translationFailed) {
        console.warn(`Translation missing: ${searchString}`)
        return capitalize(str);
    }

    return translationArr.join(' / ');
}
function capitalize(str) {
    return str && str[0].toUpperCase() + str.slice(1);
}
